import React from 'react'

export const newJerseySetupVars = {
  siteId: 'new_jersey',
  pathPrefix: '/nj',
  menuHeader: "Discover New Jersey's Solution for:",
  appUrl: 'https://nj.headed2.com',
  logoImg: '/images/assets/new_jersey/horizontal/dark.svg',
  headerTitle: `The New Jersey CareerExplorer is a system designed for New Jersey`
}
